import { LarchSys } from '../../utils/larchSys';

import './cookieconsent.js';
import './cookieconsent.scss';


export function cookieConsentFeature(larchSys: LarchSys) {

    function optInOut(didConsent: boolean) {
        //document.cookie = 'ga-opt-out=' + !didConsent + '; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/; SameSite=None; Secure';
        // TODO  gtag.js -> window['ga-disable-GA_MEASUREMENT_ID'] = true
    }

    // activate GA if the user hasn't opted out jet.
    if (!document.cookie || document.cookie.indexOf('cookieconsent_status') === -1 || document.cookie.indexOf('cookieconsent_status=dismiss') !== -1) {
        optInOut(true);
    }

    const { cookieconsent } = window as any;

    cookieconsent.initialise({
        language: larchSys.lang,
        href: '@Model.StartPage.PrivacyUrl.IfNotNull(x => x.Url)',
        theme: "block", // [block|edgeless|classic]
        "palette": {
            "popup": {
                "background": "#fff",
                "text": "#000"
            },
            "button": {
                "background": "#c5b999",
                "text": "#000"
            }
        },
        "type": "opt-out",
        "revokable": true,
        onInitialise: function (status: any) {
            const didConsent = this.hasConsented();
            optInOut(didConsent);
        },
        onStatusChange: function (status: any, chosenBefore: any) {
            const didConsent = this.hasConsented();
            optInOut(didConsent);
        },
        onRevokeChoice() {
            optInOut(false);
        }
    });

}